<style lang="scss" src='./CourseSensors.scss' scoped></style>
<template src="./CourseSensors.html"></template>

<script>
  import { getAvailableSensors, saveSensors, deleteSensors, moveSensors, getSensors } from '@/api/index';
  import { mapMutations, mapState } from 'vuex';
  import { omit } from 'lodash';

  export default {
    name: 'CourseSensors',
    components: {
    },

    data() {
      return {
        sensorsAvailable: [],
        sensorsSelected: [],
        moveActive: false,
        courseId: null,
      };
    },

    computed: {
      ...mapState('CourseSetup', {
        course: (state) => state.setupData.course,
        selectedCourse: (state) => state.setupData.course,
        sensorsStore: (state) => state.setupData.sensors,
        loading: (state) => state.loading,
        
      }),
      ...mapState('Courses', {
        courses: (state) => state.courses,
      }),

      selectedSensor() {
        let find = this.sensorsSelected.findIndex((sensor) => sensor.selected == true);
        if(find > -1){
          this.moveActive = true;
          return true;
        }
        this.moveActive = false;
        return false;
      },
    },
    
    watch: {
      sensorsStore() {
        this.sensorsSelected = [...this.sensorsStore];
      },
    },

    methods: {
      async moveSensorsToCourse(){
        let sensors = [];
        this.sensorsSelected.map((sensor) => {
          if(sensor.selected == true){
            sensors.push({"serial_number": sensor.serial_number})
          }
        });

        await moveSensors({"sensors": sensors}, this.selectedCourse.course_id)
        .then(()=>{
          this.loadSensors()
          this.$bvModal.hide('modal-move-sensors')
        })
      },

      loadSensors() {
        getSensors(this.courseId).then((res) => {
          if (res && res.sensors) {
            const sensors = res.sensors.map((s) => ({...s, selected: false}));
            this.setSetupData({'sensors': sensors});
          }
        })
      },

      showMoveSensorModal() {
        if(this.moveActive){
          this.$bvModal.show('modal-move-sensors')
        }
      },
      async continue() {
        this.setSetupData({'sensors': this.sensorsSelected.map(s => omit(s, ['selected']))});
        return true;
      },

      loadAvailableSensors() {
        this.setLoading({sensorsAvailable: true});
        getAvailableSensors().then((sensors) => {
          if (sensors && sensors.length) {
            this.sensorsAvailable = sensors.map(sensor => ({...sensor, selected: false}));
          } else {
            this.sensorsAvailable = [];
          }
        }).finally(() => {
          this.setLoading({sensorsAvailable: false});
        });
      },

      loadData() {
        this.courseId = this.$router.currentRoute.params.course_id
        this.loadAvailableSensors();
      },

      moveSensorsToSelected() {
        const sensorsSelected = this.sensorsAvailable.filter(s => s.selected);
        if (! this.G_isEmptyArr(sensorsSelected)) {
          if (this.course.course_id) {
            // Save Sensors
            this.setLoading({savingSensors: true});

            let sensorsBody = sensorsSelected.map(s => omit(s, ['selected']));
            saveSensors(this.course.course_id, sensorsBody).then(sensors => {
              this.moveSensors("sensorsAvailable", "sensorsSelected");
            }).finally(() => {
              this.setLoading({savingSensors: false});
            });

          } else {
            this.moveSensors("sensorsAvailable", "sensorsSelected");
          }
        }
      },

      moveSensorsToAvailale() {
        const sensorsSelected = this.sensorsSelected.filter(s => s.selected);
        if (! this.G_isEmptyArr(sensorsSelected)) {
          if (this.course.course_id) {
            // Delete Sensors
            this.setLoading({deletingSensors: true});

            let sensorsBody = sensorsSelected.map(s => omit(s, ['selected']));
            deleteSensors(this.course.course_id, sensorsBody).then(sensors => {
              this.moveSensors("sensorsSelected", "sensorsAvailable");
            }).finally(() => {
              this.setLoading({deletingSensors: false});
            });

          } else {
            this.moveSensors("sensorsSelected", "sensorsAvailable");
          }
        }
      },

      moveSensors(from, to){
        this[from].forEach((sensor, index) => {
          if (sensor.selected){
            this[to].push({...sensor, selected: false});
          }
        });
        this[from] = this[from].filter((sensor) => !sensor.selected);

        this.sortSensorList(this[from]);
        this.sortSensorList(this[to]);
      },

      sortSensorList(list) {
        return list.sort((a, b) => a.serial_number.localeCompare(b.serial_number));
      },

      ...mapMutations('CourseSetup', ['setCanContinue', 'setCanBack', 'setSetupData', 'setLoading']),
    },


    activated() {
      this.setCanContinue(this.continue);
      this.setCanBack(null);
    },

    mounted() {
      if (process.env.VUE_APP_SENTRY_ENV == "production") {
        this.$analytics.setCurrentScreen("Web Golf Courses Sensors");
        this.$analytics.logEvent("web_golf_courses_sensors");
      }
      this.loadData();
    },

    beforeDestroy() {
    },
  };

</script>
